import Mock from 'mockjs';
var data = Mock.mock({
  num1: '@integer(10,20)',
  num2: '@integer(10,20)',
  num3: '@integer(10,20)',
  num4: '@integer(10,20)'
});
var data2 = Mock.mock({
  'items|10': [{
    id: '@id',
    name: '@title(2,4)',
    province: '@province',
    city: '@city',
    'level|1': ['L1', 'L2', 'L3'],
    'status|1': ['Active', 'Inactive']
  }]
});
export default [{
  url: '/distributor/overview',
  type: 'get',
  response: function response(config) {
    return data;
  }
}, {
  url: '/distributor/list',
  type: 'get',
  response: function response(config) {
    var items = data2.items;
    return {
      total: items.length,
      data: items
    };
  }
}];